import cx from "classnames";
import React from "react";
import styles from "./TabNav.scss";

// Right now this is super basic and not terribly nice looking.
export const TabNav = ({ children, selected, onChange, ...props }) => {
  const styleOverrides = props.styles || {};

  const containerStyle = styleOverrides.TabNav || styles.TabNav;
  const tabStyle = styleOverrides.Tab || styles.Tab;
  const activeStyle = styleOverrides.activeTab || styles.activeTab;

  const withProps = React.Children.map(children, (tab) => {
    return React.cloneElement(tab, {
      onClick: () => onChange(tab.props.id),
      className: cx(tabStyle, tab.props.id === selected && activeStyle),
    });
  });

  return <div className={containerStyle}>{withProps}</div>;
};

export const Tab = ({ children, ...props }) => <div {...props}>{children}</div>;
